const nlTranslation = {
  common: {
    welcome: 'Welkom',
    login: 'Inloggen',
    logout: 'Uitloggen',
    send: 'Versturen',
    retry: 'Opnieuw proberen',
    loading: 'Laden...',
    error: 'Fout',
    success: 'Succes',
    cancel: 'Annuleren',
    save: 'Opslaan',
    language: 'Taal',
    newChat: 'Nieuw gesprek',
    startingNewChat: 'Nieuw gesprek starten...',
    searchMessage: 'Nadenken en relevante informatie analyseren...',
    searchMessageTiming: 'Zoeken door werkinstructies en kennisitems...',
    tryAgain: 'Probeer Opnieuw',
    back: 'Terug',
    goBack: 'Ga Terug',
    attachDocument: 'Document bijvoegen',
    aiDisclaimer:
      'Antwoorden worden gegenereerd door AI. Controleer altijd belangrijke informatie via officiële bronnen.',
    copyAnswer: 'Antwoord kopiëren',
    copyMessage: 'Bericht kopiëren',
    copied: 'Gekopieerd!',
    copyToClipboard: 'Naar klembord kopiëren',
    expand: 'Uitklappen',
    minimize: 'Inklappen',
    showMore: 'Toon meer',
    noInternalKnowledge: 'Geen interne kennis gevonden',
    noAdditionalResponse: 'Geen aanvullende reactie',
    swapMessage:
      'We hebben een bedrijfsspecifiek antwoord gevonden. Het algemene antwoord is nog steeds hieronder beschikbaar.',
    toggleShowGeneral: 'Toon algemeen antwoord (ChatGPT)',
    toggleHideGeneral: 'Verberg algemeen antwoord',
    progressExternal: 'Zoeken met ChatGPT…',
    progressInternal: 'Zoeken in bedrijfskennis…',
    internalError: 'Bedrijfskennis momenteel niet beschikbaar.',
    promoteSecondary: 'Gebruik als hoofdantwoord',
    compareAnswers: 'Vergelijk antwoorden zij aan zij',
    switchBack: 'Ga terug',
    generalInformation: 'ChatGPT',
    internalGuidelines: 'Interne richtlijnen',
  },
  knowledge_source: {
    general_info: 'Algemene informatie',
    internal_guidelines: 'Interne richtlijnen',
    internet_results: 'Internet zoekresultaten',
  },
  errors: {
    assistantResponseContentViolation:
      'De reactie van de assistent is in strijd met ons contentbeleid. Probeer het opnieuw of stel je vraag anders.',
    userInputContentViolation:
      'Je verzoek bevat inhoud die in strijd is met ons contentbeleid. Formuleer je vraag anders, alsjeblieft.',
    llmProviderUserInputBlocked:
      'Je bericht is geblokkeerd door het content filter van de AI-provider. Formuleer je vraag anders, alsjeblieft.',
    llmProviderBotResponseBlocked:
      'De AI-reactie is geblokkeerd door het content filter van de provider. Probeer het opnieuw of formuleer je vraag anders.',
    llmProviderApiError: 'We ondervinden problemen met onze AI-service. Probeer het later nog eens.',
    serverError:
      'Er is een onverwachte serverfout opgetreden. Probeer het opnieuw of neem contact op met ondersteuning als het probleem aanhoudt.',
    agentNotFound: 'De assistent die je zoekt bestaat niet of is niet meer beschikbaar.',
    conversationNotFound: 'Het gesprek dat je zoekt bestaat niet of is niet meer beschikbaar.',
    startViolatedPoliciesList: 'De volgende beleidsregels zijn overtreden',
    questionTooLong: {
      title: 'Je vraag is te lang',
      description: 'De maximale lengte is 30.000 tekens.',
    },
    excelNotSupportedYet: {
      title: 'Ondersteuning voor Excel en CSV komt binnenkort!',
      description:
        'We werken aan ondersteuning voor Excel- en CSV-bestanden die binnenkort beschikbaar zijn. Gebruik voorlopig PDF- of Word-bestanden.',
    },
  },
  auth: {
    welcomeTester: 'Welkom collega',
    welcomeMessage: 'Welkom bij Cody!',
    loginWithMicrosoft: 'Inloggen met Microsoft',
    loginInstructions: 'Log in met je Microsoft-account om te beginnen.',
  },
  chat: {
    placeholder: 'Stel hier je vraag',
    thinking: 'Bezig met denken...',
    anonymousUser: 'Anoniem',
    howToAskGoodQuestion: 'Hoe stel je een goede vraag?',
    askQuestion: 'Stel je vraag',
    exampleQuestions: 'Voorbeeldvragen',
    tryAsking: 'Probeer te vragen:',
    assistant: 'Cody, je digitale assistent',
    welcomeMessage:
      'Hallo {{name}}! Ik ben Cody, je digitale assistent. Ik kan je helpen met vragen over werkinstructies en kennisitems. Wat wil je graag weten?',
    loading: 'Gesprek laden...',
    timingKnowledge: 'TIPP',
    chatgpt: 'ChatGPT',
    internet: 'Internet',
    sensitiveInformationWarning: 'Waarschuwing: Gevoelig onderwerp, extra antwoordverificatie vereist.',
    serverError:
      'Er is een onverwachte serverfout opgetreden. Probeer het opnieuw of neem contact op met ondersteuning als het probleem aanhoudt.',
    disclaimerText:
      'Antwoorden worden gezocht in Sharepoint en gegenereerd door AI. Verifieer de bronnen bij belangrijke onderwerpen.',
  },
  internetSearch: {
    badgeLabel: 'Internet zoeken aan',
    badgeTooltip: 'Deze assistent kan internet gebruiken om te zoeken',
    inlineWarning:
      'Let op: Deel geen bedrijfsgevoelige of persoonlijke gegevens. Invoer bij internetzoeken kan door Microsoft worden gebruikt voor training.',
    dismiss: 'Afwijzen',
    modalTitle: 'Wees voorzichtig met gevoelige gegevens',
    modalBody:
      'Deze assistent gebruikt internetzoekopdrachten. Deel geen bedrijfsgevoelige of persoonlijke informatie. Invoer kan worden verwerkt door Microsoft en gebruikt worden om modellen te trainen. Deel alleen wat noodzakelijk is en houd je aan het beleid.',
    gotIt: 'Begrepen',
  },
  agentChat: {
    placeholder: 'Typ je vraag voor de agent...',
    welcomeMessage: 'Hallo, ik ben je AI-agent. Hoe kan ik je helpen?',
    privilegedWelcomeMessage: 'Hallo {{userName}}! {{description}}',
    startPrompt: 'Stel een vraag om te beginnen',
  },
  profile: {
    settings: 'Instellingen',
    selectLanguage: 'Selecteer je taal',
    appearance: 'Uiterlijk',
    darkMode: 'Donkere modus',
    languageChanged: 'Taal gewijzigd',
    noEmailAvailable: 'Geen e-mail beschikbaar',
  },
  sidebar: {
    conversations: 'Geschiedenis',
    assistants: 'Assistenten',
    info: 'Info',
    chatHistory: 'Gespreksgeschiedenis',
    today: 'Vandaag',
    thisWeek: 'Deze week',
    lastWeek: 'Vorige week',
    earlier: 'Eerder',
    conversation: 'Gesprek',
    noAssistantsAvailable: 'Geen assistenten beschikbaar',
    noContent: 'Geen inhoud',
    noPreviousConversations: 'Geen eerdere gesprekken gevonden',
    searchConversations: 'Zoek in geschiedenis...',
    noSearchResults: 'Geen geschiedenis die overeenkomt met je zoekopdracht',
    aboutCody: 'Cody, je digitale assistent',
    aboutCodyDescription: 'Cody helpt je om je werk leuker en gemakkelijker te maken.',
    dataVisibilityNoticeTitle: 'Privacyopmerking',
    dataVisibilityNoticeBody:
      "Beste gebruiker, wanneer je Cody activeert, kunnen beheerders mogelijk toegang krijgen tot de inhoud - inclusief inhoudelijke informatie - die je deelt. Uiteraard hebben collega's en derden geen toegang tot de gegevens en vragen die je indient.",
    bewareDoNotSharePersonalInformation: 'Let op: Deel geen persoonlijke informatie.',
    codyKnowledge:
      'Cody heeft kennis van alle beschikbare informatie op TIPP. Dit zijn alle kennisitems en werkinstructies over inflow, retentie en outflow.',
    codyGeneralQuestions:
      'Cody kan je ook helpen met algemene vragen, die je aan ChatGPT kunt stellen of op internet kunt vinden.',
    noPersonalQuestions: 'Cody kan geen vragen over klanten of uitzendkrachten beantwoorden.',
    noInTimeQuestions: 'Cody kan geen vragen over informatie op Intime beantwoorden, zoals nieuwsitems.',
    askClearQuestions: 'Stel een duidelijke vraag aan Cody, zodat hij je goed kan helpen.',
    conversationHistory:
      'Cody houdt rekening met je gespreksgeschiedenis. Als je dus een vervolgvraag wilt stellen, is dat mogelijk',
    startNewConversation:
      'Als je een vraag over een ander onderwerp stelt, is het beter om op "nieuw gesprek" te klikken',
    seeHowToAsk: 'zie: <1>Hoe stel je een goede vraag?</1> voor meer tips',
    aboutAssistants: 'Assistent',
    whereToFindAssistants: 'Ga naar de bibliotheek voor een overzicht van de assistenten.',
    favorites: 'Favorieten',
    noFavorites: 'Geen favorieten',
    addFavoritesHint: 'Ga naar de bibliotheek om assistenten aan je favorieten toe te voegen.',
    whenToUseAssistants: 'Gebruik "Gids door Cody" > dit helpt je bepalen waar Cody je mee kan helpen.',
    BewareAssistantsNotAgents:
      'Let op: Cody heeft assistenten, geen agents. Kortom: Cody helpt je met aparte taken als je erom vraagt, zoals het samenvatten van een e-mail. Het verstuurt de e-mail niet automatisch voor je.',
    feedback:
      'Gebruik de duimen onder het antwoord om feedback op het antwoord te geven, dit helpt Cody slimmer te maken!',
    technicalIssuesTitle: 'Technische problemen of verbeteringsvoorstel?',
    technicalIssueLogIn: 'Kun je niet inloggen of krijg je een foutmelding?',
    technicalIssueImprovementProposal: 'Heb je een algemeen verbeteringsvoorstel voor Cody?',
    technicalISsueAssistants:
      'Heb je een verbeteringsvoorstel voor een van de assistenten of wil je een nieuwe assistent aanvragen?',
    technicalIssueBeta: 'Meld dit in de Beta Testers Cody Teams-chat',
    technicalIssueNonBeta: 'Meld dit door een ticket aan te maken in <1>SSD</1>',
    loadingPrivilegedAgents: 'Cody laden...',
  },
  feedback: {
    likeAnswer: 'Antwoord leuk vinden',
    dislikeAnswer: 'Antwoord niet leuk vinden',
    feedbackSent: 'Je feedback is verzonden! ✅',
    provideFeedback: 'Geef feedback op de vraag',
    enterFeedback: 'Vul hier je feedback in',
    send: 'Verzenden',
    reasons: {
      incorrect: 'Antwoord klopt niet',
      sourceIncorrect: 'Bron klopt niet',
      other: 'Anders...',
    },
  },
  instructionModal: {
    title: 'Hoe stel je een goede vraag?',
    example: 'Voorbeeld',
  },
  instructions: {
    steps: {
      useFullSentences: {
        title: 'Gebruik volledige zinnen',
        description:
          'Probeer een volledige zin te gebruiken om misverstanden te voorkomen en meteen het best mogelijke antwoord te krijgen.',
        examples: ['"Hoe maak ik een ritafspraak" in plaats van "ritafspraak".'],
      },
      noSpecificQuestions: {
        title: 'Stel geen vragen over klanten/uitzendkrachten',
        description:
          'Cody heeft alleen kennis van TIPP werkinstructies en kennisitems, niet over klant- of uitzendkracht-specifieke informatie of andere informatie die niet op TIPP te vinden is.',
        examples: [
          'Vraag niet: "Hoeveel vakantiedagen heeft Jan Jansen nog over?", maar vraag "Waar kan ik zien hoeveel vakantiedagen mijn uitzendkracht nog over heeft?"',
        ],
      },
      askOneThingAtATime: {
        title: 'Stel één ding tegelijk',
        description:
          'Stel één vraag tegelijk. Dit helpt de chatbot om doelgerichte en nauwkeurige antwoorden te geven.',
        examples: [
          'Vraag niet "Hoeveel uur kan een uitzendkracht per week werken en wanneer wordt een shift als nachtshift beschouwd?", maar stel deze twee vragen één voor één.',
        ],
      },
    },
    aiAssistant: {
      intro:
        'Om een AI-assistent een goede vraag te stellen, wees <1>duidelijk, specifiek en geef voldoende context</1>.',
      examplesTitle: 'Voorbeelden:',
      examples: [
        'Vertel de AI wat je wilt: "Vat dit artikel samen" of "Schrijf een formele e-mail"',
        'Voeg relevante informatie toe: "Schrijf een e-mail aan een klant die te laat betaalt"',
        'Noem een stijl of toon: "Schrijf het vriendelijk maar zakelijk"',
        'Geef feedback als het antwoord niet goed is: "Maak het korter", "Gebruik minder moeilijke woorden" of "Pas het aan voor een jong publiek"',
      ],
    },
  },
  library: {
    title: 'Assistenten Bibliotheek',
    subtitle:
      'Ontdek en maak aangepaste versies van assistenten die instructies, extra kennis en elke combinatie van vaardigheden combineren.',
    searchPlaceholder: 'Zoek assistenten...',
    createAgent: 'Assistent Maken',
    createFirstAgent: 'Maak je eerste assistent',
    noAgents: 'Geen assistenten beschikbaar',
    noSearchResults: 'Geen assistenten die overeenkomen met je zoekopdracht',
    noDescription: 'Geen beschrijving beschikbaar',
    active: 'Actief',
    library: 'Bibliotheek',
    of: 'van',
    assistants: 'assistenten',
    clearFilters: 'Filters wissen',
    filtersCleared: 'Filters gewist',
    all: 'Alle',
    favorites: 'Favorieten',
    normal: 'Normaal',
    privileged: 'Geprivilegieerd',
    noTags: 'Geen tags',
    agentSelected: 'Assistent geselecteerd',
    isNowActive: 'is nu actief',
    select: 'Selecteren',
    addToFavorites: 'Toevoegen aan favorieten',
    removeFromFavorites: 'Verwijderen uit favorieten',
    moreTags: 'meer tags',
    editAgent: 'Assistent bewerken',
  },
  createAgent: {
    title: 'Nieuwe Assistent',
    subtitle: 'Maak een nieuwe AI-assistent om je team te helpen',
    saving: 'Opslaan...',
    saveAgent: 'Assistent Opslaan',
    basicInfo: 'Basisinformatie',
    classification: 'Classificatie',
    tagsAndCustomization: 'Tags & Aanpassingen',
    icon: 'Pictogram',
    name: 'Naam',
    namePlaceholder: 'Geef de assistent een naam',
    description: 'Beschrijving',
    descriptionPlaceholder: 'Beschrijf wat de assistent kan doen',
    department: 'Afdeling',
    selectDepartment: 'Selecteer een afdeling',
    jobCategory: 'Functiecategorie',
    selectJobCategory: 'Selecteer een functiecategorie',
    tags: 'Tags',
    optional: 'optioneel',
    addNewTag: 'Voeg een nieuwe tag toe',
    add: 'Toevoegen',
    existingTags: 'Bestaande tags',
    promptTemplate: 'Promptsjabloon',
    promptTemplatePlaceholder:
      'Definieer hoe de assistent moet antwoorden... (bijvoorbeeld: Je bent een helpdesk-assistent die vriendelijk en professioneel antwoord geeft op vragen over...)',
    fillAllRequiredFields: 'Vul alstublieft alle verplichte velden in',
    agentCreated: 'Assistent gemaakt',
    createdSuccessfully: 'is succesvol gemaakt',
    creationError: 'Fout bij maken',
    creationErrorDescription: 'Er is een fout opgetreden bij het maken van de assistent',
    unsavedChanges: 'Niet-opgeslagen wijzigingen',
    unsavedChangesMessage:
      'Je hebt wijzigingen aangebracht die nog niet zijn opgeslagen. Weet je zeker dat je terug wilt gaan?',
    manageJobCategories: 'Beheer functiecategorieën voor deze afdeling',
    instructions: 'Instructies',
    instructionsDescription: 'Definieer hoe je assistent zich moet gedragen en op gebruikers moet reageren',
    instructionsLabel: 'Instructies',
    instructionsPlaceholder: 'Je bent een behulpzame assistent die...',
    instructionsHelperText: 'Wees specifiek over de rol van de assistent, toon en hoe deze gebruikers kan helpen',
    instructionsMinLength: 'Instructies moeten minimaal 20 tekens zijn',
    tools: 'Gereedschappen',
    searchTool: 'Zoekgereedschap',
    toolsFileSearch: 'Bestandenzoeken',
    toolsInternetSearch: 'Internetzoeken',
    toolsHelper: 'Kies of deze assistent bijgevoegde bestanden of internet kan doorzoeken.',
    featureRequest: 'Verzoek om functie',
    deleteAssistant: 'Assistent Verwijderen',
    tagsHelp: 'Tags helpen bij het organiseren en categoriseren van je assistent',
    exampleQuestions: 'Voorbeeldvragen',
    exampleQuestionsHelp: 'Voeg voorbeeldvragen toe die gebruikers kunnen aanklikken om een gesprek te starten',
  },
  editAgent: {
    title: 'Assistent Bewerken',
    subtitle: 'Wijzig de instellingen en gedrag van je AI-assistent',
    updateAgent: 'Assistent Bijwerken',
    deleteAgent: 'Assistent Verwijderen',
    updating: 'Bijwerken...',
    deleting: 'Verwijderen...',
    agentUpdated: 'Assistent Bijgewerkt',
    updatedSuccessfully: 'is succesvol bijgewerkt',
    updateError: 'Updatefout',
    updateErrorDescription: 'Er is een fout opgetreden bij het bijwerken van de assistent. Probeer het opnieuw.',
    agentDeleted: 'Assistent Verwijderd',
    deletedSuccessfully: 'is succesvol verwijderd',
    deleteError: 'Verwijderingsfout',
    deleteErrorDescription: 'Er is een fout opgetreden bij het verwijderen van de assistent. Probeer het opnieuw.',
    deleteConfirmTitle: 'Assistent Verwijderen',
    deleteConfirmMessage:
      'Weet je zeker dat je deze assistent wilt verwijderen? Deze actie kan niet ongedaan worden gemaakt.',
    confirmDelete: 'Ja, Verwijder',
    loadingAgent: 'Assistentdetails laden...',
    failedToLoad: 'Kon assistentdetails niet laden',
  },
  jobCategory: {
    addNew: 'Categorie Toevoegen',
    name: 'Naam',
    nameRequired: 'Categorienaam is vereist',
    enterName: 'Voer categorienaam in...',
    create: 'Maken',
    edit: 'Bewerken',
    update: 'Bijwerken',
    delete: 'Verwijderen',
    created: 'Categorie Gemaakt',
    createdSuccessfully: 'is succesvol gemaakt',
    updated: 'Categorie Bijgewerkt',
    updatedSuccessfully: 'is succesvol bijgewerkt',
    deleted: 'Categorie Verwijderd',
    deletedSuccessfully: 'is succesvol verwijderd',
    creationError: 'Fout bij maken',
    creationErrorDescription: 'Er is een fout opgetreden bij het maken van de categorie',
    updateError: 'Updatefout',
    updateErrorDescription: 'Er is een fout opgetreden bij het bijwerken van de categorie',
    deletionError: 'Verwijderingsfout',
    deletionErrorDescription: 'Er is een fout opgetreden bij het verwijderen van de categorie',
    deleteError: 'Verwijderingsfout',
    deleteErrorDescription: 'Er is een fout opgetreden bij het verwijderen van de categorie',
    deleteConfirmTitle: 'Categorie Verwijderen',
    deleteConfirmMessage: 'Weet je zeker dat je "{{name}}" wilt verwijderen?',
    deleteWarning: 'Deze actie kan niet ongedaan worden gemaakt en kan invloed hebben op bestaande agenten.',
    warning: 'Waarschuwing',
    agentsWillLoseCategory: 'agenten zullen hun categoriebinding verliezen',
  },
  languageNames: {
    en: 'Engels',
    nl: 'Nederlands',
    de: 'Duits',
    fr: 'Frans',
    it: 'Italiaans',
    pl: 'Pools',
  },
  iconSelector: {
    chooseIcon: 'Kies een pictogram',
  },
}

const clientDefaults = {
  fallbackAgentDescription: 'AI assistent voor bedrijfskennis van AHV International.',
}

export default { ...nlTranslation, ...clientDefaults }
